import { render, staticRenderFns } from "./DealerTnc.vue?vue&type=template&id=1a35821c&scoped=true&"
import script from "./DealerTnc.vue?vue&type=script&lang=js&"
export * from "./DealerTnc.vue?vue&type=script&lang=js&"
import style0 from "./DealerTnc.vue?vue&type=style&index=0&id=1a35821c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a35821c",
  null
  
)

export default component.exports